import { getToken, onMessage, deleteToken, MessagePayload } from 'firebase/messaging';
import { messaging } from '../firebaseConfig';
import { FCM_VAPID_KEY } from '../constant';
import { deleteNotificationTokenService } from '../../../services/notification-service';



export const requestNotificationPermission = async (): Promise<boolean> => {
    if (!('Notification' in window)) return false;

    const permission = await Notification.requestPermission();
    return permission === 'granted';
};

const getMessagingSW = async (): Promise<ServiceWorkerRegistration | null> => {
    if (!('serviceWorker' in navigator)) return null;

    let registration =
        await navigator.serviceWorker.getRegistration('/firebase-messaging-sw.js');

    if (!registration) {
        registration = await navigator.serviceWorker.register(
            '/firebase-messaging-sw.js'
        );
    }

    await navigator.serviceWorker.ready;
    return registration;
};

export const getFcmToken = async (): Promise<string | null> => {
    try {
        const swRegistration = await getMessagingSW();
        if (!swRegistration) return null;

        let token = await getToken(messaging, {
            vapidKey: FCM_VAPID_KEY,
            serviceWorkerRegistration: swRegistration,
        });

        // If token is null → force refresh
        if (!token) {
            await deleteToken(messaging);

            token = await getToken(messaging, {
                vapidKey: FCM_VAPID_KEY,
                serviceWorkerRegistration: swRegistration,
            });
        }

        if (!token) {
            console.warn('FCM token not generated');
            return null;
        }

        console.log('FCM token:', token);
        return token;
    } catch (error) {
        console.error('FCM token error', error);
        return null;
    }
};

export const deleteFcmToken = async (): Promise<void> => {
    try {
        const employee = JSON.parse(sessionStorage.getItem('employee') || '{}');

        const swRegistration = await getMessagingSW();

        if (swRegistration) {
            await deleteToken(messaging);
        }

        if (employee?.id) {
            await deleteNotificationTokenService({
                employeeId: employee.id,
                vehicleId: 1,
            });
        }
    } catch (error) {
        console.error('Delete token error', error);
    }
};
export const onForegroundMessage = (handler: (payload: MessagePayload) => void): (() => void) => {
    return onMessage(messaging, handler);
};

export const onBackgroundMessage = (handler: (payload: MessagePayload) => void): void => {
    console.log('Setting up background message listener');
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.addEventListener('message', (event) => {
            const { type, payload } = event.data || {};
            if (type === 'FCM_MESSAGE' && payload) {
                handler(payload);
            }
        });
    }
};

